import { createElement, memo, createRef, useState, useEffect, useMemo, useRef } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import './CityList.scss';
// import { useWindowSize } from '../../../hooks/useWindowSize';
import { getCityList, getLetters } from '../cityUtil';
const isWeb = true;
const isMRN = false;
import { useWindowSize } from '../useWindowSize';
const citySelectionSearchAreaMargin = 120; // 查看 searchAreaHeight+ letterHeight
function CityList(p) {
    // 用来标注字母的dom
    const [refs, setRefs] = useState([]);
    const [cityDataSourceState, setCityDataSourcrState] = useState([]);
    const [letterHeightArr, setLetterHeightArr] = useState([0]);
    const [loadNum, setLoadNum] = useState(2);
    const heightCount = useRef(0);
    /** 城市首字母 ["A", "B", "C", "D", "E", "F", "G", "H", "J", "K", "L", "M", "N", "P", "Q", "R", "S", "T", "W", "X", "Y", "Z"] */
    const labelLetter = useMemo(() => {
        return getLetters(p === null || p === void 0 ? void 0 : p.cityData);
    }, [p === null || p === void 0 ? void 0 : p.cityData]);
    useEffect(() => {
        const allCityList = getCityList(p === null || p === void 0 ? void 0 : p.cityData);
        // 分段加载，防止因数据量过大导致卡顿
        let timer = setInterval(() => {
            setLoadNum(loadNum => {
                if (loadNum > labelLetter.length) {
                    clearInterval(timer);
                }
                return loadNum + 6;
            });
        }, 350);
        setCityDataSourcrState(allCityList);
        setRefs(labelLetter.map(() => {
            return createRef();
        }));
    }, []);
    const size = useWindowSize();
    useEffect(() => {
        setTimeout(() => {
            var _a;
            // 因为它会变化多次，到稳定时做操作
            if (true) {
                if (refs.length > 0 && refs.length === labelLetter.length) {
                    const array = labelLetter;
                    const positions = [];
                    for (let i = 0; i < array.length; i++) {
                        // 记住所有字母的位置
                        const { y } = (_a = refs[i].current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
                        const pos = y * 750 / size.width; //size.width;
                        positions.push(pos - citySelectionSearchAreaMargin);
                    }
                    p.emitPositions(positions); // 发送给父类做处理
                }
            }
        }, 1500);
    }, [refs]);
    useEffect(() => { }, [letterHeightArr]);
    const onItemLayout = index => {
        return e => {
            var _a, _b, _c;
            if (index < labelLetter.length - 1) {
                letterHeightArr[index + 1] = (_c = (_b = (_a = e.nativeEvent) === null || _a === void 0 ? void 0 : _a.layout) === null || _b === void 0 ? void 0 : _b.height) !== null && _c !== void 0 ? _c : 0;
            }
            heightCount.current++;
            if (heightCount.current === labelLetter.length) {
                setLetterHeightArr([...letterHeightArr]);
            }
        };
    };
    return <View>
      {cityDataSourceState === null || cityDataSourceState === void 0 ? void 0 : cityDataSourceState.slice(0, loadNum).map((item, index) => {
        return <View key={item.label} onLayout={onItemLayout(index)}>
              <Text className="city-list-letter" ref={refs[index]}>{item.label}</Text>
              <View className="city-list-divider-container">
                <View className="city-list-short-divider"/>
              </View>
              {item === null || item === void 0 ? void 0 : item.data.map(city => {
            return <View onClick={() => {
                p.emitCity(city, p.cityType);
            }} key={city.id}>
                      <Text className="city-list-city-name" key={city.id}>{city.name}</Text>
                    </View>;
        })}
            </View>;
    })}

    </View>;
}
export default memo(CityList);
